import CommonStyleEditor from "./CommonStyleEditor";
import { useState } from "react";
import ImagePicker from "../picker/ImagePicker";
import VideoPicker from "../picker/VideoPicker";
import { CarouselItemsQueries } from "../../../../../../requests/queries/CarouselItemsQueries";

export default function CarouselCellProperties({ cell, onChange }) {

    const [newItem, setNewItem] = useState({type: 'image', image_uri: '', video_uri: '', text: ''});

    const addItem = async () => {
        const item = await CarouselItemsQueries.createItem(cell.carousel_cell_id, newItem);
        onChange(cell.cell_id, {items: [...(cell.items || []), item]});
        setNewItem({type: 'image', image_uri: '', video_uri: '', text: ''});
    }

    return (
        <div className="property-section">
            <div className="property-section-title">Items</div>
            <div className="property-row">
                <div className="property-label">Ajouter un item</div>
                <div className="property-input-container">
                    <select className="property-input" style={{marginTop: 6}} value={newItem.type} onChange={(e) => setNewItem({...newItem, type: e.target.value})}>
                        <option value="image">Image</option>
                        <option value="video">Video</option>
                        <option value="text">Text</option>
                    </select>
                    {
                        newItem.type === 'image' && (
                            <ImagePicker value={newItem.image_uri} style={{marginTop: 6}} onChange={(image_uri) => setNewItem({...newItem, image_uri: image_uri})}/>
                        )
                    }
                    {
                        newItem.type === 'video' && (
                            <VideoPicker value={newItem.video_uri} style={{marginTop: 6}} onChange={(video_uri) => setNewItem({...newItem, video_uri: video_uri})}/>
                        )
                    }
                    {
                        newItem.type === 'text' && (
                            <textarea className="property-input" style={{marginTop: 6}} cols={16} rows={10} type="text" placeholder="Text" value={newItem.text} onChange={(e) => setNewItem({...newItem, text: e.target.value})}/>
                        )
                    }
                    <button style={{marginTop: 6}} className="property-button-add" onClick={addItem}>+</button>
                </div>
            </div>
            <div className="property-row">
                <div className="property-label">Interval</div>
                <input className="property-input property-input-small" style={{marginTop: 6}} type="number" value={cell.interval} onChange={(e) => onChange(cell.cell_id, {interval: parseInt(e.target.value), type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Loop</div>
                <input className="property-input" style={{marginTop: 6}} type="checkbox" value={cell.loop || false} onChange={(e) => onChange(cell.cell_id, {loop: e.target.checked, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Autoplay</div>
                <input className="property-input" style={{marginTop: 6}} type="checkbox" value={cell.autoplay || false} onChange={(e) => onChange(cell.cell_id, {autoplay: e.target.checked, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Controls</div>
                <input className="property-input" style={{marginTop: 6}} type="checkbox" value={cell.controls || false} onChange={(e) => onChange(cell.cell_id, {controls: e.target.checked, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Indicators</div>
                <input className="property-input" style={{marginTop: 6}} type="checkbox" value={cell.indicators || false} onChange={(e) => onChange(cell.cell_id, {indicators: e.target.checked, type: cell.type})}/>
            </div>
            <CommonStyleEditor cell={cell} onChange={onChange}/>
        </div>
    )
}